<template>
    <section>
        <div v-if="!state.showSearchForm" class="sl-header">
            <div class="sl-header-postal">
                <strong>
                    {{ locationType }} Near
                </strong>
                <span>
                    {{ state.searchPostalCode }}
                </span>
            </div>

            <button type="button" class="btn btn-sm btn-primary" title="Edit" @click="resetSearch">
                <svg width="24px" height="24px" viewBox="0 0 24 24" stroke-width="2" fill="none" xmlns="http://www.w3.org/2000/svg" color="#fff"><path d="M14.3632 5.65156L15.8431 4.17157C16.6242 3.39052 17.8905 3.39052 18.6716 4.17157L20.0858 5.58579C20.8668 6.36683 20.8668 7.63316 20.0858 8.41421L18.6058 9.8942M14.3632 5.65156L4.74749 15.2672C4.41542 15.5993 4.21079 16.0376 4.16947 16.5054L3.92738 19.2459C3.87261 19.8659 4.39148 20.3848 5.0115 20.33L7.75191 20.0879C8.21972 20.0466 8.65806 19.8419 8.99013 19.5099L18.6058 9.8942M14.3632 5.65156L18.6058 9.8942" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
            </button>
        </div>

        <div v-if="!state.showSearchForm" class="sl-result-counter">
            <span>{{ state.locations.length }} results within {{ state.searchDistance }} {{ state.distancePref }}</span>
            <button v-if="!state.showMapOnMobile" class="sl-showmap" type="button" @click="toggleMapVisibility">
                Show Map
            </button>
            <button v-if="state.showMapOnMobile" class="sl-showlist" type="button" @click="toggleMapVisibility">
                Show List
            </button>
        </div>
    </section>
</template>

<script>
import AzureMaps from '../utils/azureMaps';

export default {
    computed: {
        locationType () {
            if (this.state.searchType == 'events') return 'Fitting Events';

            if (this.state.searchType == 'retailers') return 'Retailers';

            return 'Fitting Locations';
        },
    },

    methods: {
        resetSearch () {
            this.state.showSearchForm = true;
            this.state.showMapOnMobile = false;

            try {
                document.getElementById('azure-map').classList.remove('sl-visible');
            
            } catch (e) {
                console.log(e); 
            }

            AzureMaps.clearDataSources(this.state);
            
        },

        toggleMapVisibility () {
            this.state.showMapOnMobile = !this.state.showMapOnMobile;

            try {
                if (this.state.showMapOnMobile) {
                    document.getElementById('azure-map').classList.add('sl-visible');
                } else {
                    document.getElementById('azure-map').classList.remove('sl-visible');
                }
            } catch (e) {
                console.log(e); 
            }
        }
    }
};
</script>

<style>
@media (max-width: 999px) {
    #azure-map {
        display: none;
    }
    #azure-map.sl-visible {
        display: block;
    }
}
</style>

<style scoped>
.sl-result-counter {
    border-bottom: solid 1px #ccc;
    padding: 10px 15px;
    font-size: 12px;
    display: flex;
}

.sl-header {
    background: #000;
    color: #fff;
    padding: 5px 15px;
    display: flex;
    align-items: center;
}
.sl-header-postal {
    margin-right: auto;
}
.sl-header-postal strong {
    display: block;
    font-weight: 700;
    font-size: 12px;
}
.sl-header-postal span {
    display: block;
    font-size: 16px;
}
.sl-showmap {
    color: black;
    appearance: none;
    border: none;
    background: none;
    margin: 0 0 0 auto;
    padding: 0;
    display: inline;
    font-weight: 700;
    text-decoration: underline;
}
.sl-showmap:hover {
    text-decoration: none;
}
.sl-showlist {
    color: black;
    appearance: none;
    border: none;
    background: none;
    margin: 0 0 0 auto;
    padding: 0;
    display: inline;
    font-weight: 700;
    text-decoration: underline;
}
.sl-showlist:hover {
    text-decoration: none;
}

@media (min-width: 1000px) {
    .sl-showmap, .sl-showlist {
        display: none;
    }
}
</style>